import React from 'react';
import {HealthContainer} from '../components/HealthContainer/healthContainer';

export const HealthUser = () => {
  return (
    <HealthContainer title={'Clever Health User'}>
      <div />
    </HealthContainer>
  );
};
